import MongoModel from './MongoModel'

export default class Organization extends MongoModel {
  modelName = 'Organization'
  collection = 'organizations'
  autoFields = true

  defaults () {
    return {
      id: null,
      name: null,
      settings: {},
      users: []
    }
  }
}
